export default __webpack_public_path__ + "img/578df3c8a004332ee32cd9cc717a5d74.svg";